var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMustache(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 4C2.75 3.58579 2.41421 3.25 2 3.25C1.58579 3.25 1.25 3.58579 1.25 4V20C1.25 20.4142 1.58579 20.75 2 20.75C2.41421 20.75 2.75 20.4142 2.75 20V8.84797C3.6864 10.5417 5.64273 12 9.38677 12C10.4768 12 11.4371 11.4692 12 10.6633C12.5629 11.4692 13.5232 12 14.6132 12C21.3109 12 22.2877 7.33333 21.9388 5C21.9388 6.04286 18.5072 7.67795 15.428 6.41168C14.8749 6.18425 14.28 5.96135 13.7034 6.1279C12.9992 6.33132 12.3995 6.76474 12 7.33672C11.6005 6.76474 11.0008 6.33132 10.2966 6.1279C9.71997 5.96135 9.12512 6.18425 8.57204 6.41168C6.33249 7.33264 3.90656 6.71888 2.75 5.91444V4ZM15.1557 11.9554C14.9647 11.9736 14.7831 11.9884 14.6132 12C14.7982 12 14.9795 11.9847 15.1557 11.9554ZM8.8443 11.9554C9.02051 11.9847 9.20177 12 9.38677 12C9.21693 11.9884 9.03529 11.9736 8.8443 11.9554Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMustache);
export default __webpack_public_path__ + "static/media/mustache.dc70321c0e7783c5dc22258687be9a7a.svg";
export { ForwardRef as ReactComponent };